import { useSyncExternalStore } from "react";

function applyProfileV2UrlOverride(): void {
    if (typeof window === "undefined") return;
    try {
        const value = new URLSearchParams(window.location.search).get(
            "profileV2",
        );
        if (value === "1") window.localStorage.setItem("profile-v2", "1");
        else if (value === "0") window.localStorage.setItem("profile-v2", "0");
    } catch {}
}

function readProfileV2DataFlag(): boolean {
    if (typeof window === "undefined") return false;
    try {
        const stored = window.localStorage.getItem("profile-v2");
        if (stored === "1") return true;
        if (stored === "0") return false;
    } catch {}
    return import.meta.env.VITE_PUBLIC_PROFILE_V2 !== "false";
}

export function useProfilePageDataEnabled(): boolean {
    return useSyncExternalStore(
        (listener) => {
            applyProfileV2UrlOverride();
            window.addEventListener("storage", listener);
            return () => window.removeEventListener("storage", listener);
        },
        readProfileV2DataFlag,
        () => false,
    );
}
